/** @format */

import validator from 'validator';

const filled = (value) => !validator.isEmpty(value);
const required = (value) => {
  return !!value;
};

const isAlphaFa = (value) => {
  const regex = /^[\u0600-\u06FF\s]+$/;
  return regex.test(value);
};

const checkIsEmpty = (value) => {
  if (value == null || value == undefined) return true;
  if (`${value}`.length == 0) return true;
  return false;
};

const isMax = (value, max) =>
  !checkIsEmpty(value) ? validator.isFloat(String(value), { max: +max }) : true;
const isMin = (value, min) =>
  !checkIsEmpty(value) ? validator.isFloat(String(value), { min: +min }) : true;

const isGt = (value, max) => (!checkIsEmpty(value) ? value.length > max : true);
const isLt = (value, min) => (!checkIsEmpty(value) ? value.length <= min : true);
const isLength = (value, lng) => (value.length ? value.length === Number(lng) : true);

const isNumeric = (value) => (!checkIsEmpty(value) ? validator.isNumeric(value) : true);

const isEmail = (value) => (!checkIsEmpty(value) ? validator.isEmail(value) : true);

const isAlphaEn = (value) => {
  const regex = /^[a-z\d\-_\s]+$/i;
  return regex.test(value);
};

const isUsername = (value) => {
  if (checkIsEmpty(value)) return true;
  const regex = /(?!.*[\.\-\_]{2,})^[a-zA-Z0-9\.\-\_]{3,64}$/;
  return regex.test(value);
};

const isNationalCode = (code) => {
  // ✓ : Revised
  if (checkIsEmpty(code)) return true;
  var str = code.toString();

  // validate the string length and value
  const strLen = str.length;
  const strVal = parseInt(str);
  if (strLen < 8 || strLen > 10 || isNaN(strVal) || strVal == 0) return false;

  // make sure the string is padded with zeros
  while (str.length < 10) str = `0${str}`;

  // invalidate consecutive arrangement of the same digit
  if (str.match(/^(\d)\1+$/g)) return false;

  const checkDigit = parseInt(str.slice(-1)); // rightmost digit
  var str = str.slice(0, -1); // remove the check digit

  for (var sum = 0, i = str.length; i > 0; i--) sum += (i + 1) * str.substr(-i, 1);

  // calculate sum modulo 11
  const mod = sum % 11;

  return (mod < 2 && mod === checkDigit) || (mod >= 2 && mod + checkDigit === 11);
};

const isMobile = (value) => {
  // ✓ : Revised
  if (checkIsEmpty(value)) return true;
  const regex = /^((?:\+98|0)(\d){2}(\d){8})$/;
  return regex.test(value);
};

const isPostalCode = (value) => {
  // ✓ : Revised
  if (checkIsEmpty(value)) return true;
  const regex = /^(\d{5}-?\d{5})$/;
  return regex.test(value);
};

// Sheba
function iso7064Mod97_10(iban) {
  // ✓ : Revised
  let remainder = iban;
  let block;

  while (remainder.length > 2) {
    block = remainder.slice(0, 9);
    remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length);
  }

  return parseInt(remainder, 10) % 97;
}

const isShebaAccount = (str) => {
  // ✓ : Revised
  if (checkIsEmpty(str)) return true;

  let value = str;

  if (str.toUpperCase().length === 24 && !str.toUpperCase().startsWith('IR')) {
    value = `IR${str}`;
  }

  const pattern = /IR[0-9]{24}/;

  if (value.length !== 26) {
    return false;
  }

  if (!pattern.test(value)) {
    return false;
  }

  let newStr = value.substr(4);
  const d1 = value.charCodeAt(0) - 65 + 10;
  const d2 = value.charCodeAt(1) - 65 + 10;
  newStr += d1.toString() + d2.toString() + value.substr(2, 2);

  const remainder = iso7064Mod97_10(newStr);
  if (remainder !== 1) {
    return false;
  }

  return true;
};

const isCardNumber = (code) => {
  // ✓ : Revised
  if (checkIsEmpty(code)) return true;

  const L = code.length;
  if (L < 16 || parseInt(code.substr(1, 10), 10) == 0 || parseInt(code.substr(10, 6), 10) == 0)
    return false;
  const c = parseInt(code.substr(15, 1), 10);
  let s = 0;
  let k;
  let d;
  for (let i = 0; i < 16; i++) {
    k = i % 2 == 0 ? 2 : 1;
    d = parseInt(code.substr(i, 1), 10) * k;
    s += d > 9 ? d - 9 : d;
  }
  return s % 10 == 0;
};

const isEconomicCode = (value) => {
  if (!value) return true;
  const regex = /^(?=.{10,15}$)[0-9]*$/;
  return regex.test(value);
};

const isURL = (value) => {
  const expression =
    /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
  const regex = new RegExp(expression);
  return regex.test(value);
};

const isURLAndNotRequierd = (value) => {
  const expression =
    /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$|^$/;
  const regex = new RegExp(expression);
  return regex.test(value);
};

const isAppHash = (value) => {
  if (!value) return true;

  const expression = /^[A-Za-z0-9+\/=]{11}$/;
  const regex = new RegExp(expression);
  return regex.test(value);
};
const isNotHtmlTags = (value) => {
  const regex = /(<([^>]+)>)/gi;
  return !regex.test(value);
};
const isNotContainTag = (value) => {
  const expression = /<[^>]*>/g;
  const regex = new RegExp(expression);
  return !regex.test(value);
};
const isValidLength = (value) => {
  const min = 5;
  const max = 30;
  return [...value].length >= min && [...value].length <= max;
};
const isCorrectPostalCode = (value) => {
  if (!String(value).length) {
    return true;
  }
  const expression = /^(?!.*0000$)[13456789][13456789][13456789][13456789][1346789][123456789][0-9]{4}$/gi;
  const regex = new RegExp(expression);
  return regex.test(value);
};


const validators = {
  filled,
  required,
  isAlphaFa,
  isAlphaEn,
  isNationalCode,
  isMobile,
  isPostalCode,
  isShebaAccount,
  isCardNumber,
  isEconomicCode,
  isMax,
  isMin,
  isGt,
  isLt,
  isURL,
  isURLAndNotRequierd,
  isLength,
  isNumeric,
  isEmail,
  isUsername,
  isAppHash,
  isNotHtmlTags,
  isNotContainTag,
  isCorrectPostalCode,
  isValidLength
};

validator.validators = {
  ...validator,
  ...validators,
};

export default validator;
